import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/cn.js';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, style, ...rest }, ref) {
    return (
      <input
        ref={ref}
        className={cn(
          'h-11 w-full rounded-lg border bg-surface px-3 text-base text-ink',
          'placeholder:text-ink-subtle',
          'focus:outline-none focus:ring-2 focus:ring-brand-300 focus:border-brand',
          'disabled:opacity-50 disabled:bg-surface-muted',
          className,
        )}
        style={{ borderColor: 'var(--color-border-secondary)', ...style }}
        {...rest}
      />
    );
  },
);
